module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-amarillo.b0b61f2c.svg";